export const sliderItems = [
  {
      id: 1,
      imageUrl: "https://images.pexels.com/photos/7314292/pexels-photo-7314292.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      title: "Women",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "#ffcedf",
  },
  {
      id: 2,
      imageUrl: "https://images.pexels.com/photos/9953929/pexels-photo-9953929.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      title: "Men",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "#fff9da",
  },
  {
      id: 3,
      imageUrl: "https://images.pexels.com/photos/9399679/pexels-photo-9399679.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "#FCF7FC",
  },
  {
    id: 4,
    imageUrl: "https://images.pexels.com/photos/6784755/pexels-photo-6784755.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "#FCF7FC",
},
];




export const sections = [
  {
    title: 'hats',
    imageUrl: 'https://i.ibb.co/cvpntL1/hats.png',
    id: 1,
    linkUrl: 'shop/hats'
  },
  {
    title: 'jackets',
    imageUrl: 'https://i.ibb.co/px2tCc3/jackets.png',
    id: 2,
    linkUrl: 'shop/jackets'
  },
  {
    title: 'sneakers',
    imageUrl: 'https://i.ibb.co/0jqHpnp/sneakers.png',
    id: 3,
    linkUrl: 'shop/sneakers'
  },
  {
    title: 'women',
    imageUrl: 'https://i.ibb.co/GCCdy8t/womens.png',
    size: 'large',
    id: 4,
    linkUrl: 'shop/womens'
  },
  {
    title: 'men',
    imageUrl: 'https://i.ibb.co/R70vBrQ/men.png',
    size: 'large',
    id: 5,
    linkUrl: 'shop/mens'
  }
];

export default sections;
